import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import { tokens, success, alert_2, GET, POST, PUT, DELETE, validate, required, getStorage, loading } from "../../components/CustomComponent.js";
import React, { Component } from "react";
import Pagination from '@mui/material/Pagination';
import { Modal } from "react-bootstrap";

const r_det = getStorage("role_detail")?.find(i => i.name === "pay-list")?.role || [];
const [view_r, create_r, update_r, delete_r] = [r_det[0] === 1, r_det[1] === 1, r_det[2] === 1, r_det[3] === 1];

export default class ProfileCode extends Component {
    state = {
        modal_create: false, modal_update: false, modal_delete: false,
        page: 1, filter_data_search: "", data: null,
        pay_id: "", code: "", title: ""
    };

    componentDidMount() {
        loading(false);
        if (view_r) this.GetAll();
    }

    GetAll = async () => {
        loading(true);
        let r = await GET(tokens, `v1/TH/document-manage/pay-list/filter-search/page/${this.state.page}`, { data_search: this.state.filter_data_search });
        if (r?.status) this.setState({ data: r.data });
        loading(false);
    };

    handleSave = async (isCreate) => {
        if (validate(this.state, ["code", "title"])) return;
        loading(true);
        let { pay_id, code, title } = this.state;
        let payload = isCreate ? { code, title } : { pay_id, code, title };
        let r = await (isCreate ? POST : PUT)(tokens, `v1/TH/document-manage/pay-list/${isCreate ? 'create' : 'update'}`, payload);
        if (r?.status) {
            alert_2("#","success");
        }
        loading(false);
    };
    
    Delete = async () => {
        loading(true);
        let r = await DELETE(tokens, `v1/TH/document-manage/pay-list/delete/${this.state.pay_id}`, null);
        if (r?.status) {
            alert_2("#","success");
        }
        loading(false);
    };

    clear_form = () => this.setState({
        modal_create: false, modal_update: false, modal_delete: false,
        page: 1, filter_data_search: "", pay_id: "", code: "", title: ""
    });

    render() {
        const s = this.state;
        return (
            <div className="w-100 min-vh-100 fade-in">
                <Navbar page1="หน้าหลัก" page2="ตั้งค่า" page3="รหัสบัญชี" />
                <div className="body">
                    <div className="p-3">
                        <div className="card border-0 p-3">
                            <div className="d-flex row mx-0 align-items-center justify-content-between">
                                <h4 className="mb-3"><b>รายการรับชำระ</b></h4>
                                {create_r && <button className="btn btn-primary px-4 mx-1 mb-3" onClick={() => this.setState({ modal_create: true })}>เพิ่มรายการรับชำระ</button>}
                            </div>
                            
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped">
                                    <thead>
                                        <tr className="bg-dark-blue text-white">
                                            <th className="text-left">รหัส</th>
                                            <th className="text-left">รายการ</th>
                                            {(update_r || delete_r) && <th className="text-center wpx-90">จัดการ</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!s.data?.data?.length ? (
                                            <tr><td colSpan={3} className="text-center">ไม่มีข้อมูล</td></tr>
                                        ) : s.data.data.map((item, i) => (
                                            <tr key={i}>
                                                <td>{item.code || "-"}</td>
                                                <td>{item.title || "-"}</td>
                                                {(update_r || delete_r) && (
                                                    <td className="text-center d-flex">
                                                        {update_r && (
                                                            <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center mr-2">
                                                                <label className="icon mx-2 text-primary pointer" onClick={() => this.setState({ modal_update: true, pay_id: item.pay_id, code: item.code, title: item.title })}>{"\uf304"}</label>
                                                            </label>
                                                        )}
                                                        {i !== 0 && delete_r && (
                                                            <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center">
                                                                <label className="icon mx-2 text-danger pointer" onClick={() => this.setState({ modal_delete: true, pay_id: item.pay_id })}>{"\uf2ed"}</label>
                                                            </label>
                                                        )}
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            
                            {s.data?.data?.length > 0 && (
                                <div className="d-flex justify-content-between row mx-0 w-100 px-3">
                                    <div><label>แสดง {s.data.end_index} รายการ จาก {s.data.count} รายการ</label></div>
                                    <Pagination count={s.data.page_number} page={s.page} color="primary" showFirstButton showLastButton onChange={(e, v) => this.setState({ page: v }, this.GetAll)} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <Modal show={s.modal_create || s.modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })}>
                    <Modal.Header><Modal.Title><b>{s.modal_create ? "เพิ่มรหัสบัญชี" : "แก้ไขรหัสบัญชี"}</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        <div className="w-100 d-flex align-items-center mb-3">
                            <label className="wpx-140">รหัสบัญชี{required}:</label>
                            <input className="form-control border-0 bg-contain validate" type="text" placeholder="กรอกข้อมูล" value={s.code} readOnly={s.modal_update} onChange={(e) => this.setState({ code: e.target.value })} />
                        </div>
                        <div className="w-100 d-flex align-items-center mb-3">
                            <label className="wpx-140">ชื่อรหัสบัญชี{required}:</label>
                            <input className="form-control border-0 bg-contain validate" type="text" placeholder="กรอกข้อมูล" value={s.title} onChange={(e) => this.setState({ title: e.target.value })} />
                        </div>
                        <div className="w-100 d-flex">
                            <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_create: false, modal_update: false })}>ยกเลิก</button></div>
                            <div className="w-50 p-1"><button className="btn btn-primary w-100" onClick={() => this.handleSave(s.modal_create)}>บันทึก</button></div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={s.modal_delete} onHide={() => this.setState({ modal_delete: false })}>
                    <Modal.Header><Modal.Title><b>ยืนยันการลบรหัสบัญชี</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        <div className="w-100 d-flex mb-3"><label>ท่านแน่ใจว่าต้องการลบรหัสบัญชี หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้</label></div>
                        <div className="w-100 d-flex">
                            <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_delete: false })}>ยกเลิก</button></div>
                            <div className="w-50 p-1"><button className="btn btn-danger w-100" onClick={this.Delete}>ยืนยัน</button></div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}